// removed by extract-text-webpack-plugin
module.exports = {"Profile":"_3owYD3lfd6YQGGdTICLGNA","ProfileSidebar":"_3EDwXP52G8mSFlfJlgms5y","DefaultLangSwitch":"AJWrzPt8dkF6hCzJl_YDI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/styles.css
// module id = 199
// module chunks = 0